import { Actions } from './smtp-settings.actions'
import { fromJS } from 'immutable'
import * as SmtpSettingsTypes from './smtp-settings.types'

export const initialState = fromJS<any>({
  isLoading: false,
  validationErrors: {},
  data: {},
})

export function smtpSettingsReducer(state = initialState, action: Actions) {
  switch (action.type) {
    case SmtpSettingsTypes.UPDATE_SMTP_SETTINGS_REQUEST: {
      return state.set('isLoading', true)
    }

    case SmtpSettingsTypes.UPDATE_SMTP_SETTINGS_SUCCESS: {
      return state.set('isLoading', false)
    }

    case SmtpSettingsTypes.UPDATE_SMTP_SETTINGS_FAILURE: {
      return state.set('isLoading', false)
    }

    case SmtpSettingsTypes.FETCH_SMTP_SETTINGS_REQUEST: {
      return state.set('isLoading', true)
    }

    case SmtpSettingsTypes.FETCH_SMTP_SETTINGS_SUCCESS: {
      return state.set('isLoading', false).set('data', fromJS(action.payload))
    }

    case SmtpSettingsTypes.FETCH_SMTP_SETTINGS_FAILURE: {
      return state.set('isLoading', false)
    }

    case SmtpSettingsTypes.UPDATE_FIELD:
      let fields = []

      if (action.path === '') {
        fields = action.field.split('.')
      } else {
        fields = action.path.split('.').concat(action.field.split('.'))
      }
      const value = action.value

      if (fields.length === 1) {
        return state.set(fields[0], fromJS(value))
      }
      return state.setIn(fields, fromJS(value))
    case SmtpSettingsTypes.SET_DEFAULT_DATA:
      const path = action.path || ''
      return state.setIn(path.split('.'), initialState.getIn(path.split('.')))

    default:
      return state
  }
}
